import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <div className="homepage-container">
        {/* Matrix Background Elements */}
        <div className="matrix-background">
          {/* Binary Rain Background */}
          <div className="binary-rain">
            {Array.from({ length: 20 }, (_, i) => (
              <div key={i} className={`binary-column column-${i}`}>
                {Array.from({ length: 30 }, (_, j) => (
                  <span key={j} className={`binary-char char-${j}`}>
                    {Math.random() > 0.5 ? '1' : '0'}
                  </span>
                ))}
              </div>
            ))}
          </div>
          
          {/* Digital Grid */}
          <div className="digital-grid">
            {Array.from({ length: 12 }, (_, i) => (
              <div key={i} className={`grid-line horizontal line-${i}`}></div>
            ))}
            {Array.from({ length: 20 }, (_, i) => (
              <div key={i} className={`grid-line vertical line-${i}`}></div>
            ))}
          </div>
          
          {/* Floating Code Fragments */}
          <div className="code-fragments">
            <div className="fragment fragment-1">{'<API>'}</div>
            <div className="fragment fragment-2">{'{ JSON }'}</div>
            <div className="fragment fragment-3">{'HTTP/2'}</div>
            <div className="fragment fragment-4">{'REST'}</div>
            <div className="fragment fragment-5">{'POST'}</div>
            <div className="fragment fragment-6">{'GET'}</div>
            <div className="fragment fragment-7">{'PUT'}</div>
            <div className="fragment fragment-8">{'200 OK'}</div>
            <div className="fragment fragment-9">{'404'}</div>
            <div className="fragment fragment-10">{'Bearer'}</div>
          </div>
          
          {/* Cyber Particles */}
          <div className="cyber-particles">
            {Array.from({ length: 15 }, (_, i) => (
              <div key={i} className={`particle particle-${i}`}></div>
            ))}
          </div>
        </div>
        
        <div className="header">
          <h1 className="site-title">XAIAPI</h1>
          <p className="site-subtitle">Advanced AI API Solutions</p>
        </div>
        
        <div className="data-stream-container">
          <div className="data-stream">
            {/* Enhanced Matrix-style falling code */}
            <div className="code-rain">
              {Array.from({ length: 15 }, (_, i) => (
                <div key={i} className={`code-column column-${i}`}>
                  {Array.from({ length: 25 }, (_, j) => (
                    <span key={j} className={`code-char char-${j}`}>
                      {Math.random() > 0.7 ? (
                        ['API', 'GET', 'POST', 'JSON', 'HTTP', 'REST', 'PUT', 'DEL'][Math.floor(Math.random() * 8)]
                      ) : (
                        Math.random() > 0.5 ? '1' : '0'
                      )}
                    </span>
                  ))}
                </div>
              ))}
            </div>
            
            {/* Enhanced Data Packets */}
            <div className="data-packets">
              <div className="packet packet-red">JSON</div>
              <div className="packet packet-blue">XML</div>
              <div className="packet packet-green">CSV</div>
              <div className="packet packet-orange">API</div>
              <div className="packet packet-purple">SQL</div>
              <div className="packet packet-cyan">REST</div>
              <div className="packet packet-yellow">HTTP</div>
            </div>
            
            {/* Enhanced Processing Center */}
            <div className="processing-center">
              <div className="processor-core">
                <div className="core-ring core-ring-1"></div>
                <div className="core-ring core-ring-2"></div>
                <div className="core-ring core-ring-3"></div>
                <div className="core-inner">AI</div>
                <div className="core-glow"></div>
              </div>
              <div className="processing-waves">
                <div className="wave wave-1"></div>
                <div className="wave wave-2"></div>
                <div className="wave wave-3"></div>
                <div className="wave wave-4"></div>
              </div>
              
              {/* Data Flow Lines */}
              <div className="data-flow-lines">
                <div className="flow-line line-1"></div>
                <div className="flow-line line-2"></div>
                <div className="flow-line line-3"></div>
                <div className="flow-line line-4"></div>
              </div>
            </div>
            
            {/* Digital Terminals */}
            <div className="digital-terminals">
              <div className="terminal terminal-1">
                <div className="terminal-header">ENDPOINT_01</div>
                <div className="terminal-content">
                  <div className="terminal-line">$ curl -X GET</div>
                  <div className="terminal-line">Status: <span className="status-ok">200</span></div>
                </div>
              </div>
              
              <div className="terminal terminal-2">
                <div className="terminal-header">ENDPOINT_02</div>
                <div className="terminal-content">
                  <div className="terminal-line">$ POST /api/v1</div>
                  <div className="terminal-line">Auth: <span className="status-success">OK</span></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="footer-text">
          <p>Powering Innovation Through Intelligent APIs</p>
        </div>
      </div>
    </div>
  );
}

export default App;